import React, { useState, useEffect } from 'react';
import { FiUser, FiMail, FiPhone, FiMapPin, FiCamera, FiSave } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import Swal from 'sweetalert2';

export default function AdminProfilePage() {
  const { user } = useAuth();
  
  // โหลดค่าโปรไฟล์เริ่มต้นจาก localStorage หรือ user object
  const [profile, setProfile] = useState({
    name: localStorage.getItem('profile_name') || user?.name || 'สมชาย แสนดี',
    email: localStorage.getItem('profile_email') || user?.email || 'owner@thundermaxhome.com',
    phone: localStorage.getItem('profile_phone') || '081-234-5678',
    address: localStorage.getItem('profile_address') || '123/45 ถนนประเสริฐมนูกิจ แขวงนวมินทร์ เขตบึงกุ่ม กรุงเทพฯ 10230',
    avatarUrl: localStorage.getItem('profile_avatar') || 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=150&q=80'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdateProfile = (e) => {
    e.preventDefault();
    
    // บันทึกลงใน localStorage
    localStorage.setItem('profile_name', profile.name);
    localStorage.setItem('profile_email', profile.email);
    localStorage.setItem('profile_phone', profile.phone);
    localStorage.setItem('profile_address', profile.address);
    localStorage.setItem('profile_avatar', profile.avatarUrl);

    Swal.fire({
      title: 'บันทึกสำเร็จ!',
      text: 'ข้อมูลโปรไฟล์ส่วนตัวของท่านได้รับการบันทึกเรียบร้อยแล้ว',
      icon: 'success',
      confirmButtonText: 'ตกลง'
    });
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6 text-left">
      <div className="mb-8">
        <h1 className="text-2xl font-black text-gray-800 dark:text-white">🧑‍💻 โปรไฟล์ส่วนตัว</h1>
        <p className="text-xs text-gray-500 mt-1">จัดการข้อมูลส่วนตัว รูปถ่าย ชื่อ ที่อยู่ อีเมล และเบอร์โทรศัพท์ของท่าน</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* ฝั่งซ้าย: การ์ดรูปโปรไฟล์ */}
        <div className="bg-gradient-to-br from-indigo-900 to-indigo-950 text-white p-6 rounded-2xl shadow-lg h-fit flex flex-col items-center text-center">
          <div className="relative group mb-4">
            <img 
              src={profile.avatarUrl} 
              alt="Profile" 
              className="w-24 h-24 rounded-full object-cover border-4 border-white/20 shadow-md"
              onError={(e) => {
                e.target.src = 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=150&q=80';
              }}
            />
            <div className="absolute inset-0 bg-black/60 rounded-full opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center cursor-pointer">
              <FiCamera size={18} className="text-white" />
            </div>
          </div>
          
          <h2 className="text-lg font-bold truncate max-w-full">{profile.name}</h2>
          <p className="text-indigo-300 text-xs mt-0.5 font-mono">{user?.username || 'owner'}</p>
          
          <div className="mt-6 bg-indigo-800/40 w-full p-2.5 rounded-xl border border-indigo-700/50 flex items-center justify-center gap-2">
            <span className="font-extrabold text-[10px] text-yellow-400 uppercase tracking-widest">
              ★ {user?.role === 'owner' ? 'Owner / เจ้าของระบบ' : user?.role?.toUpperCase() || 'ADMIN'}
            </span>
          </div>
        </div>

        {/* ฝั่งขวา: ฟอร์มแก้ไขข้อมูล */}
        <div className="md:col-span-2 bg-white dark:bg-[#131825] p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 transition-colors">
          <h3 className="text-sm font-bold mb-5 flex items-center gap-2 text-gray-850 dark:text-white">
            <FiUser className="text-indigo-500" /> แก้ไขข้อมูลประจำตัว
          </h3>
          
          <form onSubmit={handleUpdateProfile} className="space-y-4 text-xs">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">ชื่อ-นามสกุล</label>
                <input 
                  type="text" 
                  name="name"
                  value={profile.name}
                  onChange={handleChange}
                  className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500" 
                  placeholder="กรอกชื่อและนามสกุล"
                  required
                />
              </div>
              <div>
                <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">รูปโปรไฟล์ (URL)</label>
                <input 
                  type="text" 
                  name="avatarUrl"
                  value={profile.avatarUrl}
                  onChange={handleChange}
                  className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500 font-mono" 
                  placeholder="ลิ้งค์รูปถ่ายส่วนตัว"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">อีเมลติดต่อ</label>
                <input 
                  type="email" 
                  name="email"
                  value={profile.email}
                  onChange={handleChange}
                  className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500" 
                  placeholder="name@example.com"
                  required
                />
              </div>
              <div>
                <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">เบอร์โทรศัพท์</label>
                <input 
                  type="text" 
                  name="phone"
                  value={profile.phone}
                  onChange={handleChange}
                  className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500" 
                  placeholder="08X-XXX-XXXX"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">ที่อยู่ปฏิบัติงาน/สำนักงาน</label>
              <textarea 
                name="address"
                value={profile.address}
                onChange={handleChange}
                rows="3"
                className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500" 
                placeholder="กรอกที่อยู่ปัจจุบันโดยละเอียด"
                required
              />
            </div>

            <div className="pt-2">
              <button 
                type="submit" 
                className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-5 rounded-xl transition flex items-center gap-2"
              >
                <FiSave /> บันทึกการเปลี่ยนแปลง
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}